<template>
  <b-sidebar id="sidebar-nav-page" class="pl-5" aria-labelledby="sidebar-nav-page-title" shadow backdrop no-header-close>
    <template #title="{ hide }">
      <div class="d-flex align-items-center px-3 py-2">
        <div class="mr-auto"></div>
        <a type="button" size="sm" class="navbar-toggler nav-link" @click="hide">&#x2715;</a>
       </div>
    </template>
    <template #default="{ hide }">
      <div class="sidebar-custom d-flex flex-column align-items-start">
        <!-- Content visible pages show company (not logged). - <EMPRESA>.abler.com.br -->
        <menu-logged-out v-if="!userIsLoggedIn" :current-scoped-company-page="currentScopedCompanyPage" sidebar />
        <!-- Content visible pages show company (company - logged). - <EMPRESA>.abler.com.br -->
        <menu-logged-in v-if="userIsLoggedIn" :current-scoped-company-page="currentScopedCompanyPage" sidebar />
        <!-- Social Media Icons. - <EMPRESA>.abler.com.br -->
        <social-media-icons class="mt-auto mx-auto" :current-scoped-company-page="currentScopedCompanyPage" />
      </div>
    </template>
  </b-sidebar>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import menuLoggedOut from '../navbar/menu-logged-out.vue';
import menuLoggedIn from '../navbar/menu-logged-in.vue';
import SocialMediaIcons from '../navbar/social-media-icons.vue';

export default {
  name: 'Sidebar',
  components: {
    menuLoggedOut,
    menuLoggedIn,
    SocialMediaIcons,
  },
  computed: {
   ...mapGetters('UserStore', [
      'userIsLoggedIn',
    ]),
    ...mapState('CompanyStore', [
      'currentScopedCompanyPage',
    ]),
  },
};

</script>

<style> 
  .sidebar-custom {
    padding: 2rem;
    margin: 0;
    width: 100%;
    height: 100% !important;
    overflow-y: auto;
    overflow-x: hidden;
    position: relative;
    background-color: #fff;
    border-right: 1px solid #e7e7e7;
  }

  .b-sidebar-header {
    display: block !important;
    padding: 0 !important;
  }

  .navbar-toggler {
    margin-right: 0 !important;
  }
</style>
